<template>
    <div class="top-menu">

        <a class="nvg-link" href="#/contact">Contact</a>
        <ul id="vertical-navigation">
            <!-- Begin parent item -->
            <li class="">

                <span class="k-link">
                    How to apply
                    <span class="k-icon k-i-arrow-60-down k-menu-expand-arrow"></span>
                </span>
                <!-- Begin Child Items Group-->
                <ul>

                    <!-- Begin Child Item-->
                    <li class=""><a class="nvg-link" href="/#/visaprocess">Visa Process</a> </li>
                    <li class=""><a class="nvg-link" href="/#/appterms">Visa Application Terms</a> </li>
                    <li class=""><a class="nvg-link" href="/#/needvisa">Do I need a Visa</a></li>
                    <li class=""><a class="nvg-link" href="/#/req_photo">Photo Requirements</a></li>
                    <li class=""><a class="nvg-link" href="/#/req_passport">Passport Requirements</a></li>
                </ul>
                <!-- End Child Items Group-->

            </li>
            <!-- End parent item -->
        </ul>
        <a class="nvg-link" href="/#/covid">COVID-19 Protocol</a>
    </div>
</template>
<script>

    import { Menu, MenuItem } from '@progress/kendo-layout-vue-wrapper';

    export default {
        name: 'Menu',
        props: {
            ShowContinueSubmission: {
                type: Boolean,
                default: false,
            }
        },

        components: {
            'kendo-menu': Menu,
            'kendo-menu-item': MenuItem
        },

        data: () => ({

        }),
        methods: {
            onSelect: function (e) {
                var currentItemText = $(e.item.firstChild).text().trim();
                //console.log(currentItemText + " clicked.");
            },
        }
    }
</script>